module.exports = __webpack_public_path__ + "img/101ne.38355c38.svg";